import { QueryStatus } from '@adv-frontend/modules-query';
import { useIntegrationGetWebmasterHostInfo } from '#entities/integration';
import { SITE_NOT_PUBLISHED_WEBMASTER_GUARD, YANDEX_VERIFICATION_SETTING_PATH } from './constants';
import { getSiteVerificationConnectionStatus } from './getSiteVerificationConnectionStatus';
import { getWebmasterPermissionDeniedGuard } from './guards';
import { useIsSitePublished } from './useIsSitePublished';
import { useVerificationCodeSetting } from './useVerificationCodeSetting';

export const useWebmasterSiteVerificationStatus = () => {
    const { data, status: automaticStatus, refetch: refetchAutomaticStatus } = useIntegrationGetWebmasterHostInfo();
    const { verificationCode } = useVerificationCodeSetting(YANDEX_VERIFICATION_SETTING_PATH);
    const isSitePublished = useIsSitePublished();
    const verificationStatus = data?.verification_status;
    const isAutomaticallyConnected = verificationStatus === 'VERIFIED';
    const { hasVerificationCode, isConnected } = getSiteVerificationConnectionStatus({
        isAutomaticallyConnected,
        verificationCode,
    });

    let guardReason: string | undefined;

    if (!isConnected && verificationStatus === 'PERMISSION_DENIED') {
        guardReason = getWebmasterPermissionDeniedGuard(data?.owner_email);
    } else if (!isConnected && !isSitePublished) {
        guardReason = SITE_NOT_PUBLISHED_WEBMASTER_GUARD;
    }

    return {
        automaticStatus,
        guardReason,
        hasVerificationCode,
        isAutomaticStatusError: automaticStatus === QueryStatus.rejected,
        isAutomaticStatusPending: automaticStatus === QueryStatus.pending || verificationStatus === 'IN_PROGRESS',
        isAutomaticallyConnected,
        isConnected,
        isSitePublished,
        ownerEmail: data?.owner_email,
        refetchAutomaticStatus,
        verificationStatus,
    };
};
